// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_he-0";